export default "__VITE_ASSET__D3WA8BFn__"